var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKalenderCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2692 2.15381H2.73077C1.77489 2.15381 1 2.9287 1 3.88458V14.2692C1 15.2251 1.77489 16 2.73077 16H14.2692C15.2251 16 16 15.2251 16 14.2692V3.88458C16 2.9287 15.2251 2.15381 14.2692 2.15381Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94351 8.5003C10.4214 8.5003 10.8089 8.11285 10.8089 7.63492C10.8089 7.15698 10.4214 6.76953 9.94351 6.76953C9.46557 6.76953 9.07812 7.15698 9.07812 7.63492C9.07812 8.11285 9.46557 8.5003 9.94351 8.5003Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8283 8.5003C13.3062 8.5003 13.6937 8.11285 13.6937 7.63492C13.6937 7.15698 13.3062 6.76953 12.8283 6.76953C12.3503 6.76953 11.9629 7.15698 11.9629 7.63492C11.9629 8.11285 12.3503 8.5003 12.8283 8.5003Z",
    fill: "#9B9B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94351 11.3846C10.4214 11.3846 10.8089 10.9971 10.8089 10.5192C10.8089 10.0413 10.4214 9.65381 9.94351 9.65381C9.46557 9.65381 9.07812 10.0413 9.07812 10.5192C9.07812 10.9971 9.46557 11.3846 9.94351 11.3846Z",
    fill: "#9B9B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8283 11.3846C13.3062 11.3846 13.6937 10.9971 13.6937 10.5192C13.6937 10.0413 13.3062 9.65381 12.8283 9.65381C12.3503 9.65381 11.9629 10.0413 11.9629 10.5192C11.9629 10.9971 12.3503 11.3846 12.8283 11.3846Z",
    fill: "#9B9B9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17203 11.3846C4.64996 11.3846 5.03741 10.9971 5.03741 10.5192C5.03741 10.0413 4.64996 9.65381 4.17203 9.65381C3.69409 9.65381 3.30664 10.0413 3.30664 10.5192C3.30664 10.9971 3.69409 11.3846 4.17203 11.3846Z",
    fill: "#9B9B9B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05874 11.3846C7.53668 11.3846 7.92413 10.9971 7.92413 10.5192C7.92413 10.0413 7.53668 9.65381 7.05874 9.65381C6.58081 9.65381 6.19336 10.0413 6.19336 10.5192C6.19336 10.9971 6.58081 11.3846 7.05874 11.3846Z",
    fill: "#9B9B9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17203 14.2693C4.64996 14.2693 5.03741 13.8819 5.03741 13.404C5.03741 12.926 4.64996 12.5386 4.17203 12.5386C3.69409 12.5386 3.30664 12.926 3.30664 13.404C3.30664 13.8819 3.69409 14.2693 4.17203 14.2693Z",
    fill: "#9B9B9B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05874 14.2693C7.53668 14.2693 7.92413 13.8819 7.92413 13.404C7.92413 12.926 7.53668 12.5386 7.05874 12.5386C6.58081 12.5386 6.19336 12.926 6.19336 13.404C6.19336 13.8819 6.58081 14.2693 7.05874 14.2693Z",
    fill: "#9B9B9B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94351 14.2693C10.4214 14.2693 10.8089 13.8819 10.8089 13.404C10.8089 12.926 10.4214 12.5386 9.94351 12.5386C9.46557 12.5386 9.07812 12.926 9.07812 13.404C9.07812 13.8819 9.46557 14.2693 9.94351 14.2693Z",
    fill: "#9B9B9B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88477 1V2.15385M13.1155 1V2.15385",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.0387H1",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalenderCard);
export default __webpack_public_path__ + "static/media/kalender-card.2982d4d0bc2e88b7e6fb4a62c7ac55cb.svg";
export { ForwardRef as ReactComponent };